// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609161835/js/" + chunkId + "." + {"44":"a5e18fc3","225":"83147687","481":"8fbcf77b","486":"2cbe1c6a","770":"6999768a"}[chunkId] + ".0.8940986037693692.chunk.js";
};